import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env file');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          email: string;
          full_name: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email: string;
          full_name?: string | null;
        };
        Update: {
          id?: string;
          email?: string;
          full_name?: string | null;
        };
      };
      licenses: {
        Row: {
          id: string;
          user_id: string;
          license_key: string;
          tier: string;
          status: string;
          device_fingerprint: string | null;
          device_info: Record<string, unknown> | null;
          purchased_at: string;
          activated_at: string | null;
          expires_at: string | null;
          max_device_resets: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          user_id: string;
          license_key: string;
          tier?: string;
          status?: string;
          device_fingerprint?: string | null;
          device_info?: Record<string, unknown> | null;
          purchased_at?: string;
          activated_at?: string | null;
          expires_at?: string | null;
          max_device_resets?: number;
        };
        Update: {
          user_id?: string;
          license_key?: string;
          tier?: string;
          status?: string;
          device_fingerprint?: string | null;
          device_info?: Record<string, unknown> | null;
          activated_at?: string | null;
          expires_at?: string | null;
          max_device_resets?: number;
        };
      };
    };
  };
};
